import React, {Component} from 'react';

import $ from 'jquery';
import firebase from 'firebase';
import _HauteFire from '../../Utils/HauteFire';
const HauteFire = new _HauteFire();

export default class ExclusiveFeatures extends Component {
    constructor() {
        super();

        this.state = {ExclusiveFeatures: [], CopyExclusiveFeatures: []};
    }

    componentDidMount() {
        this.getExclusiveFeatures();
    }

    getExclusiveFeatures() {
        const _this = this;

        let featureRef = firebase.database().ref('ExclusiveFeatures/');
        featureRef.on('value', ((response) => {
            const ExclusiveFeatures = response.val();
            if (ExclusiveFeatures && ExclusiveFeatures.length > 0) {
                _this.setState({ExclusiveFeatures, CopyExclusiveFeatures: ExclusiveFeatures});

                _this.setExclusiveFeatures();
            }
        }))
    }

    setExclusiveFeatures(e) {
        // let feature = e.currentTarget.value.trim();
        let feature = $("#txtFeature").val().trim();
        if (feature != "") {
            const ExclusiveFeatures = this.state.CopyExclusiveFeatures;
            if (ExclusiveFeatures && ExclusiveFeatures.length > 0) {
                let includedFeatures = ExclusiveFeatures.filter((_feature) => {
                    return _feature.name.toLowerCase().includes(feature.toLowerCase())
                });
                if (includedFeatures && includedFeatures.length > 0) {
                    this.setState({ExclusiveFeatures: includedFeatures});
                }
            }
        } else {
            const ExclusiveFeatures = this.state.CopyExclusiveFeatures;

            this.setState({ExclusiveFeatures});
        }
    }

    addExclusiveFeature(e) {
        if (e.keyCode == 13) {
            let feature = e.currentTarget.value.trim();
            if (feature != "") {
                let CopyExclusiveFeatures = this.state.CopyExclusiveFeatures;
                if (CopyExclusiveFeatures && CopyExclusiveFeatures.length > 0) {
                    const includedFeatures = CopyExclusiveFeatures.filter((obj) => {
                        return obj.name.toLowerCase() == feature
                    })
                    if (includedFeatures.length == 0) {
                        CopyExclusiveFeatures.push({name: feature, count: 0});
                        this.setState(CopyExclusiveFeatures);

                        HauteFire.addExclusiveFeatures(CopyExclusiveFeatures);
                    }
                }
                else {
                    CopyExclusiveFeatures.push({name: feature, count: 0});

                    HauteFire.addExclusiveFeatures(CopyExclusiveFeatures);
                }
            }
        }
    }

    renderFeatures(feature, index) {
        return (
            <div className="chip" key={index}>
                <span className="chip-count">{feature.count}</span>
                {feature.name}
                <span className="chip-close">&times;</span>
            </div>
        );
    }

    renderNoFeaturesExist() {
        return (
            <div style={{textAlign:'center'}}>
                <strong style={{fontFamily: 'Cabin Sketch ,cursive', fontSize: '-webkit-xxx-large'}}>No features
                    exist</strong>
                <img src="../../../../img/rsz_sad.gif" style={{padding:10}}/>
            </div>
        )
    }

    render() {
        return (
            <div className="animated fadeIn">

                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <input id="txtFeature" type="text" className="form-control" placeholder="Add feature"
                                       autoFocus={true}
                                       onInput={this.setExclusiveFeatures.bind(this)}
                                       onKeyUp={this.addExclusiveFeature.bind(this)}
                                />
                            </div>

                            <div className="card-block">

                                {this.state.ExclusiveFeatures.length > 0 ? this.state.ExclusiveFeatures.map((feature, index) => {
                                    return this.renderFeatures(feature, index)
                                }) : this.renderNoFeaturesExist()}

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/IslandManagement/ExclusiveFeatures/ExclusiveFeatures.js